//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';
// import { findIndex, map, cloneDeep, filter } from 'lodash';


//  ----------------------------------------------------------------------------
//  Reducers
//  ----------------------------------------------------------------------------

//  -- Example ------------------------
const audioPlaying = {
    isPlaying: false,id:""
}

export const audioPlayer = (state = audioPlaying, action) => {
    switch (action.type) {
        case ActionTypes.audioChecker.getAudioCheckerInit:
            return state;
        case ActionTypes.audioChecker.setAudioChecker:
            return {...state,...action.payload}
        default:
            return state;
    }
};
